// extracted by mini-css-extract-plugin
export default {"error":"Logs_error__GKiTj","success":"Logs_success__hVdHy"};